import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4cf64943"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "component c-bl2" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "c-gy2 pb1" }, "Products", -1))
const _hoisted_3 = { class: "card-grid" }
const _hoisted_4 = { class: "card mr1" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "c-gr" }, "NFL Statistics University", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "c-gr" }, "Website", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "c-gy1" }, "Here we do statistical analysis on NFL games. View fun stats or even get a let up in fantasy football", -1))
const _hoisted_8 = { class: "card ml1" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "c-gr" }, "Speed Grocer", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "c-gr" }, "Mobile App - iOS & Android", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "c-gy1" }, "Grocery App that solves all your grocery problems! Learn more by checking it the website", -1))


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectsComponent',
  setup(__props) {

    
    function openNewTab(url: string) {
      window.open('http://'+url, '_blank');
    }
    
  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", null, [
          _hoisted_5,
          _hoisted_6,
          _hoisted_7,
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (openNewTab('nflstatuni.com')))
          }, "View")
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", null, [
          _hoisted_9,
          _hoisted_10,
          _hoisted_11,
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (openNewTab('speedgrocer.io')))
          }, "View")
        ])
      ])
    ])
  ]))
}
}

})